import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeComponentCalloutFields {
  title?: EntryFieldTypes.Symbol
  type: EntryFieldTypes.Symbol<'example' | 'info' | 'success' | 'warning'>
  hideHeader?: EntryFieldTypes.Boolean
  body?: EntryFieldTypes.RichText
}

export type TypeComponentCalloutSkeleton = EntrySkeletonType<TypeComponentCalloutFields, 'componentCallout'>
export type TypeComponentCallout<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeComponentCalloutSkeleton,
  Modifiers,
  Locales
>

export function isTypeComponentCallout<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeComponentCallout<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'componentCallout'
}
